import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import './carousel.css';
import '../../../resources/styles/index.scss';
import { Carousel } from 'react-responsive-carousel';
import view, { carouselMode, oyoFormView } from '../../../Enums';
import { Event, PageView, initGA } from '../Tracking/Track';
import BecomeAnOyoScreen from '../../BecomeAnOyo/BecomeAnOyoScreen';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { hmsSelfOnboardingEnabled, selfOnboardingEnabled } from '../../../config/countryConfig';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Popper from '@material-ui/core/Popper';
import UserIcon from '../../../resources/vectors/UserIcon';
import { isEmptyString, path } from '../../../utils/index';
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded';
import HandShake from '../../../resources/vectors/HandShake';
import CallRoundedIcon from '@material-ui/icons/CallRounded';
import { Link } from 'react-router-dom';
import SimpleCountDownTimer from '../../../ui-components/Timer/SimpleCountDown';
import { centerAbs } from '../../../resources/styles';
import pages, { getRouteForPage } from '../../../PageEnums';
import OYO360Logo from '../../../resources/vectors/OYO360Logo';

class LandingImage extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    initGA();
    PageView();
  }

  state = {
    initialSwipe: false,
    showContactDD : false
  };

  
  getImagesForCarousel = image_id => {
    if (!(image_id in LandingImages)) return [];
    const image = this.props.globalData.universal_translations[
      LandingImages[image_id][this.props.viewMode]
    ];
    const images = (image && image.split(',')) || [];
    return images.map(item => `${S3HOST}/${item}`);
  };

  render() {

    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    let rightForMailDiv = 224;
    if (guc('call') && guc('call').length > 20) rightForMailDiv = 396;
    let images = [];
    switch (this.props.globalData.carousel_mode) {
      case carouselMode.HOME:
        images = this.getImagesForCarousel('oyo_big_image_home');
        break;
      case carouselMode.SIGN_UP:
        images = this.getImagesForCarousel('oyo_big_image_sign_up');
        break;
      default:
        images = this.getImagesForCarousel('oyo_big_image');
        break;
    }

    const oyoSaathiEnabled = this.props.globalData.country_iso_code == 'in';

    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && (
          <div style={{ position: 'relative' }}>
            <div
              style={{
                ...gs('landing_parent'),
                height: this.props.landingImageHeight + 'px',
                overflow: 'hidden'
              }}
            >
              { hmsSelfOnboardingEnabled() ? <div
                      style={{...gs('oyo_white'),
                      width: this.props.viewMode == view.DESKTOP ? '10vw': '25vw',
                      top: '32px' }}>
                    <OYO360Logo/>
              </div> :
                  <img style={gs('oyo_white')} src={gi('OYO_WHITE')} />}
              
              {!selfOnboardingEnabled() && this.props.viewMode == view.DESKTOP && <div style={{position:'absolute',right:0,top:30,width:475,zIndex:1,display:'flex'}}>

                {oyoSaathiEnabled &&
                    <div style={{
                        color: isEmptyString(gc('email_color')) ? 'white' : gc('email_color'),
                        fontSize: '16px',
                        display: 'flex'
                    }}>
                        <span style={{ padding: '3px 5px 0px 0px', opacity: '0.8' }}>
                            <Link to={getRouteForPage(pages.OYO_SAATHI)}><HandShake /></Link>
                        </span>
                        <span style={{
                            ...gs('mail_text_style'),
                            textShadow: isEmptyString(gc('email_shadow')) ? gs('mail_text_style')['textShadow'] : gc('email_shadow')
                        }}>
                            <Link to={getRouteForPage(pages.OYO_SAATHI)}>OYO Saathi</Link>
                        </span>
                    </div>
                }


                <div style={{
                  color: isEmptyString(gc('email_color')) ? 'white' : gc('email_color'),
                  fontSize: '16px',
                  display: 'flex'
                }}>
                  <span style={{ padding: '3px 5px 0px 0px', opacity: '0.8' }}>
                    <a
                        href={guc('email_us_link')}
                        onClick={() => {
                          Event('Partner Page', 'Contact icon clicked', '', '');
                        }}>
                      <MailOutlineRoundedIcon fontSize='small'/>
                    </a>
                  </span>
                  <span style={{
                    ...gs('mail_text_style'),
                    textShadow: isEmptyString(gc('email_shadow')) ? gs('mail_text_style')['textShadow'] : gc('email_shadow')
                  }}>
                  <a
                      href={guc('email_us_link')}
                      onClick={() => {
                        Event('Partner Page', 'E-Mail icon clicked', '', '');
                      }}
                  >
                    {guc('email')}
                  </a>
                </span>
                </div>
  
                <div style={{
                  color: isEmptyString(gc('call_color')) ? 'white' : gc('call_color'),
                  fontSize: '16px',
                  marginLeft: '15px',
                  display: 'flex'
                }}>
                  <span style={{ paddingRight: '5px', opacity: '0.8' }}>
                    <a href={guc('call_us_link')}>
                      <CallRoundedIcon fontSize='small'/>
                    </a>
                  </span>
                  <span style={{
                    ...gs('call_text_style'),
                    textShadow: isEmptyString(gc('call_shadow')) ? gs('call_text_style')['textShadow'] : gc('call_shadow')
                  }}>
                  {' '}
                    <a href={guc('call_us_link')}>{guc('call')}</a>
                </span>
                </div>
              </div>}


              {this.props.viewMode == view.DESKTOP && (selfOnboardingEnabled() || hmsSelfOnboardingEnabled()) && (
                <div
                  style={{...gs('landing_image_header'), ...this.props.additionalHeaderStyles }}
                >
                  <div style={{ width: '120px' }}>
                    <a href={'https://www.oyorooms.com/about?oyocorporate='} >
                      {guc('abt_oyo')}
                    </a>
                  </div>

                  {oyoSaathiEnabled && <div style={{ width: '120px' }}><Link to={getRouteForPage(pages.OYO_SAATHI)}>OYO Saathi</Link></div>}
                  
                  <ClickAwayListener
                      onClickAway={() => {this.setState({showContactDD:false})}}
                  >
                    
                    <div
                        onClick={(e) => {
                          this.setState({
                            showContactDD:!this.state.showContactDD,
                            contactDdAnchor:e.currentTarget
                          })
                        }}
                        className="hover"
                        style={{ width: '120px',position:'relative' }}
                    >
                      {guc('contact_us')}
                      <Popper open={this.state.showContactDD} anchorEl={this.state.contactDdAnchor} placement={'bottom'}>
                          <div style={gs('mail_phone_div')}>
                            <div style={gs('mail_div')}>
                            <a href={guc('email_us_link')}>
                              <div
                                  className={'hoverColorGray'}
                              >
                                {guc('email_us')}
                              </div>
                            </a>
                            </div>
                            {!guc('calling_disabled') && <div style={gs('call_div')}>
                            <a href={guc('call_us_link')}>
                              <div
                                  className={'hoverColorGray'}
                              >
                                {guc('call_us_at')}
                              </div>
                            </a>
                            </div>}
                          </div>
                      </Popper>
                      
                    </div>
                  </ClickAwayListener>
                  <div
                    onClick={(e) => {
                      if (hmsSelfOnboardingEnabled()) this.props.redirectToHms();
                      else this.props.changeOyoForm(oyoFormView.loginScreen);
                    }}
                    style={gs('green_button')}
                    className={'hoverColor'}
                  >
                    <div style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}><AccountCircleIcon style={{
                      width: '17px',
                      marginRight: '3px',
                      height: '17px',
                    }}/>{guc('login')}</div>
                  </div>
                </div>
              )}

              {this.props.viewMode == view.MOBILE && <>
                <div style={gs('mail_phone_div')}>

                  {oyoSaathiEnabled && <div style={{ ...gs('mail_div'), right: rightForMailDiv + 'px' , color: isEmptyString(gc('email_color')) ? 'white' : gc('email_color')}}>
                    <Link to='/oyosaathi'>
                      <div style={{
                        ...gs('contact_border_circle'),
                        borderColor: isEmptyString(gc('contact_border')) ? 'rgba(255,255,255,0.5)' : gc('contact_border')
                      }}>
                        <HandShake style={gs('contact_icon')}/>
                      </div>
                    </Link>
                    <span style={gs('mail_text_style')}><Link to='oyosaathi'>OYO Saathi</Link></span>
                </div>}

                  <div
                    style={{ ...gs('mail_div'), right: rightForMailDiv + 'px' , color: isEmptyString(gc('email_color')) ? 'white' : gc('email_color')}}
                  >
                    <a
                      href={guc('email_us_link')}
                      onClick={() => {
                        Event('Partner Page', 'Contact icon clicked', '', '');
                      }}
                    >
                      <div style={{
                        ...gs('contact_border_circle'),
                        borderColor: isEmptyString(gc('contact_border')) ? 'rgba(255,255,255,0.5)' : gc('contact_border')
                      }}>
                        <MailOutlineRoundedIcon fontSize='small' style={gs('contact_icon')}/>
                      </div>
                    </a>
                    <span style={gs('mail_text_style')}>
                      <a
                        href={guc('email_us_link')}
                        onClick={() => {
                          Event('Partner Page', 'E-Mail icon clicked', '', '');
                        }}
                      >
                        {guc('email')}
                      </a>
                    </span>
                  </div>

                  <div style={{...gs('call_div'), color: isEmptyString(gc('call_color')) ? 'white' : gc('call_color')}}>
                    <a href={guc('call_us_link')}>
                      <div style={{
                        ...gs('contact_border_circle'),
                        borderColor: isEmptyString(gc('contact_border')) ? 'rgba(255,255,255,0.5)' : gc('contact_border')
                      }}>
                        <CallRoundedIcon fontSize='small' style={gs('contact_icon')}/>
                      </div>
                    </a>
                    <span style={gs('call_text_style')}>
                      {' '}
                      <a href={guc('call_us_link')}>{guc('call')}</a>
                    </span>
                  </div>
                  
                  {(selfOnboardingEnabled() || hmsSelfOnboardingEnabled()) && <UserIcon
                      style={{
                        zIndex:1,
                        marginRight:'20px',
                        color:'white',
                        border:'solid 0.05px rgba(180,180,180)',
                        padding:'7px',
                        borderRadius:'20px' }
                      }
                      onClick={e => {
                        if (hmsSelfOnboardingEnabled()) this.props.redirectToHms();
                        else {
                          this.props.changeOyoForm(oyoFormView.loginScreen);
                          this.props.handleScrollToForm();
                        }
                      }}
                  ></UserIcon>}
                  
                </div>
                
              </>}
              <div id="landingCaraousel1" className="landingcarousel">
                {this.props.globalData.carousel_mode && (
                  <Carousel
                    showStatus={false}
                    autoPlay={images.length>1}
                    infiniteLoop={images.length>1}
                    ref={instance => {
                      setTimeout(() => {
                        if (images.length>1 && instance && !this.state.initialSwipe) {
                          instance.onClickNext();
                          this.setState({ initialSwipe: true });
                        }
                      }, 3000);
                    }}
                  >
                    {images.map((img, index) => (
                      <div
                          style={{
                            width: '100%',
                            height: this.props.landingImageHeight + 'px',
                            overflow: 'hidden',
                            position:'relative'
                          }}
                      >
                        <img
                          style={{
                            width: '100%',
                            height: '100%'
                          }}
                          onLoad={() => {
                            if (index === 0) this.props.landingImageLoad();
                          }}
                          key={index}
                          src={img}
                          alt="OYO"
                        />
                        {img.match(/us_2020_christmas/) &&
                        
                        <div style={gs('timer_parent')}>
                          <span style={gs('limited_time_offer')}>LIMITED TIME OFFER</span>
                          <SimpleCountDownTimer
                              style={{marginBottom:'auto'}}
                              targetEpoch={new Date('December 31, 2020 23:59:59').getTime()}
                              boxStyle={gs('limited_offer_box')}
                              subTextSize={this.props.viewMode == view.DESKTOP?10:6}/>
                        </div>
                        
                        }
                        
                      </div>
                      
                    ))}
                  </Carousel>
                )}
              </div>
            </div>
            {(selfOnboardingEnabled() || hmsSelfOnboardingEnabled()) && <BecomeAnOyoScreen
              gc = {gc}
              guc = {guc}
              gs = {gs}
              gi = {gi}
              showMessageModal={this.props.showMessageModal}
              viewMode={this.props.viewMode}
              rightMarginForForm={this.props.rightMarginForForm}
              highLightForm={this.props.highLightForm}
              amount={this.props.amount}
              utm_data={this.props.utm_data}
              giveAbilityToChangeOyoForm={this.props.giveAbilityToChangeOyoForm}
              redirectToHms={this.props.redirectToHms}
            />}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingImage);
